import { Directive, ElementRef, Input } from '@angular/core';
import { CarouselComponent } from '@df/ui-carousel/carousel.component';

@Directive({
    selector: '[twoDimensionalCarouselSection]',
    standalone: true
})
export class TwoDimensionalCarouselSectionDirective {
    @Input()
    set twoDimensionalCarouselSection(value: number) {
        this.index = value;
    }

    public index = 0;

    constructor(public elementRef: ElementRef, public carousel: CarouselComponent) {}

    runAnimations(): void {
        const animations = this.elementRef.nativeElement.querySelectorAll('.animation-reveal, .animation-fade-in');

        animations.forEach((element: HTMLElement) => {
            if (!element.classList.contains('is-animate')) {
                element.classList.add('is-animate');
            }
        });
    }
}
